import React, { useEffect, useState } from 'react';
import { find, get } from 'lodash';

import { STATUS_SUCCEEDED, useResourceValues } from 'src/presentation/hooks/useResource';
import DnsRecordsListForm from './DnsRecordsListForm';
import EmailDomain from 'src/models/Email/EmailDomain';
import emailDomainsResource from 'src/actions/email/emailDomainsResource';

const AddEmailDomainStep2 = ({
  nextStep,
  currentEmailDomain,
}: {
  nextStep?;
  currentEmailDomain?: EmailDomain | null;
}): JSX.Element | null => {
  const [emailDomain, setEmailDomain] = useState<EmailDomain>();

  const { loadingState, values } = useResourceValues(emailDomainsResource);

  useEffect(() => {
    if (loadingState === STATUS_SUCCEEDED) {
      const emailDomains = get(currentEmailDomain, 'content.customerDomain');
      const match = find(values, domain => get(domain, 'content.customerDomain') === emailDomains);

      if (match) {
        setEmailDomain(match);
      }
    }
  }, [currentEmailDomain, loadingState, setEmailDomain, values]);

  return (
    <DnsRecordsListForm
      item={emailDomain}
      onNextButtonClick={nextStep}
      nextButtonName="Next"
      loadingState={loadingState}
    />
  );
};

export default AddEmailDomainStep2;
